module.exports = __webpack_public_path__ + "static/media/400125_01.0e3e7c6c.png";